import { baseApi } from '@/features/api/baseApi';
import directus, { type DirectusErrorType, type RequestQuery } from '@/features/api/directus';
import type { DirectusUsers } from '@/models/types';
import { readMe, readUsers } from '@directus/sdk';

const userApi = baseApi
  .enhanceEndpoints({
    addTagTypes: ['directus_users', 'directus_me'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getDirectusMe: builder.query<DirectusUsers, void>({
        queryFn: async () => {
          try {
            const data = await directus.request<DirectusUsers>(readMe());
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['directus_me'],
      }),
      getDirectusUsers: builder.query<DirectusUsers[], RequestQuery<DirectusUsers> | undefined>({
        // `readItems` refuse les collections système (`directus_*`) : `readUsers` est requis.
        queryFn: async query => {
          try {
            const data = await directus.request<DirectusUsers[]>(readUsers(query as never));
            return { data };
          } catch (error: unknown) {
            return { error: error as DirectusErrorType };
          }
        },
        providesTags: ['directus_users'],
      }),
    }),
  });

export const { useGetDirectusMeQuery, useGetDirectusUsersQuery } = userApi;
